<template>
	<div class="content">
		<LayoutBanner />

		<div class="about min_cw ql-snow">
			<div class="top">
				<h2 class="title">关于我们</h2>
			</div>

			<div v-loading="loading" class="con ql-editor" v-html="infoData.content"></div>
		</div>
	</div>
</template>

<script>
import LayoutBanner from "@/components/Layout/banner";
import {getAboutUsInfoApi} from "@/api";

export default {
	name: "index",
	components: {
		LayoutBanner,
	},
	data() {
		return {
			loading: false,
			infoData: {},
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.loading = true;
			const res = await getAboutUsInfoApi();
			this.infoData = res.data && res.data[0] ? res.data[0] : {};
			this.infoData.remark = this.infoData.remark ? this.infoData.remark.replaceAll("\n", "<br>") : "";
			this.loading = false;
		},
	}
}
</script>

<style lang="less" scoped>
.about {
	padding: 60px 40px;

	.top {
		margin-bottom: 50px;

		.title {
			font-size: 22px;
			color: @blackLine;
			line-height: 1.6;
		}
	}
}
</style>
